import Button from './Button'

const defaultImg =
  'https://fcp-site-images.s3.eu-west-3.amazonaws.com/1_Federacio_Contacte_610401c835.jpg'

const Hero = ({
  media,
  text,
  ctaText,
  ctaLink,
  ctaExternal,
  sectionName,
  full
}) => (
  <div className="bg-white">
    <div
      className={`relative h-[504px] ${full ? 'lg:h-[900px]' : 'lg:h-[700px]'}`}
    >
      <div className="absolute inset-x-0 bottom-0 h-full bg-gray-100" />
      <div className="mx-auto h-full">
        <div className="relative shadow-xl sm:overflow-hidden h-full">
          <div className="absolute inset-0 h-full object-cover">
            {media?.mime.includes('video') ? (
              <video autoPlay muted loop className="h-full w-full object-cover">
                <source src={media.url} type={media.mime}></source>
              </video>
            ) : (
              <img
                className="h-full w-full object-cover"
                src={media?.url || defaultImg}
                alt=""
              />
            )}
            {/* <div className="absolute inset-0 bg-blue opacity-60 mix-blend-multiply" /> */}
          </div>
          {text && (
            <div className="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8 h-full flex flex-col justify-center">
              <h1 className="text-center text-4xl tracking-tight sm:text-5xl lg:text-[100px] text-accent font-normal">
                {text}
              </h1>
              {ctaText && (
                <div className="mx-auto mt-10 max-w-sm sm:flex sm:max-w-none sm:justify-center">
                  <Button
                    link={ctaLink}
                    text={ctaText}
                    target={ctaExternal || '_self'}
                  />
                </div>
              )}
            </div>
          )}
          {sectionName && (
            <div className="relative p-16 sm:p-24 lg:p-32 h-full flex flex-col justify-end">
              <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-[100px] text-white">
                {sectionName}
              </h1>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
)

export default Hero
